module.exports = __webpack_public_path__ + "static/img/黄赌毒.d25b00a.png";


//////////////////
// WEBPACK FOOTER
// ./static/hunanDIY/黄赌毒.png
// module id = /hhY
// module chunks = 24